import { MOBILE_NAV_CLEARANCE_PX } from '~/constants/layout'

export const zendeskWidgetColors = {
  theme: '#1a1a1a',
  launcher: '#262626',
  launcherText: '#e6e6e6',
  button: '#333333',
  header: '#1a1a1a',
}

export const zendeskWidgetSettings = {
  webWidget: {
    position: {
      horizontal: 'right',
      vertical: 'bottom',
    },
    offset: {
      horizontal: '0px',
      vertical: '0px',
      mobile: {
        horizontal: '25px',
        vertical: `${MOBILE_NAV_CLEARANCE_PX}px`,
      },
    },
    color: zendeskWidgetColors,
    zIndex: 1101,
  },
}

export function mergeZendeskSettings(existing = {}) {
  const { webWidget: localWebWidget } = zendeskWidgetSettings
  const { webWidget: existingWebWidget = {} } = existing

  return {
    ...existing,
    webWidget: {
      ...existingWebWidget,
      ...localWebWidget,
      position: {
        ...existingWebWidget.position,
        ...localWebWidget.position,
      },
      offset: {
        ...existingWebWidget.offset,
        ...localWebWidget.offset,
        mobile: {
          ...existingWebWidget.offset?.mobile,
          ...localWebWidget.offset.mobile,
        },
      },
      color: {
        ...existingWebWidget.color,
        ...localWebWidget.color,
      },
    },
  }
}
